<template>
  <div v-if="sendInfo" class="move-fedex">
    <div class="time">
      <img class="img" src="../../assets/imgs/send-fedex.png" />
      <div class="time-info">
        <p class="title">
          <span v-if="sendInfo.pickup" class="text-value">
            Pick up on {{ sendInfo.pickupTimeRange }}
          </span>
          <span v-else class="tag">{{ sendInfo.pickup | pickUp }}</span>
        </p>
        <p
          v-if="sendInfo.pickup"
          class="btn note"
          @click="newWindow('https://support.movingkite.com/hc/en-us/articles/4404707626779')"
        >
          Notes for pick up >
        </p>
        <p v-else class="btn note" @click="newWindow('https://local.fedex.com/en-us')">Find FedEx locations nearby ></p>
      </div>
    </div>
    <div class="ship-info">
      <div class="row">
        <div class="long">
          <p class="title">Name</p>
          <p class="value">{{ sendInfo.sendFirstName }} {{ sendInfo.sendLastName }}</p>
        </div>
        <div class="shot">
          <p class="title">Phone</p>
          <p class="value">{{ sendInfo.sendMobile }}</p>
        </div>
      </div>
      <div class="row">
        <div class="long">
          <p class="title">City, State/Province</p>
          <p class="value">{{ sendInfo.sendCity }}, {{ sendInfo.sendState }} {{ sendInfo.sendCountry }}</p>
        </div>
        <div class="shot">
          <p class="title">Zip code</p>
          <p class="value">{{ sendInfo.sendPostcode }}</p>
        </div>
      </div>
      <div class="row">
        <div class="long">
          <p class="title">Address</p>
          <p class="value">{{ sendInfo.sendAddr1 }}</p>
          <p class="value">{{ sendInfo.sendAddr2 }}</p>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MoveFedex',
  filters: {
    pickUp(pickup) {
      return pickup ? 'Pick-up' : 'Drop off';
    },
    time(time) {
      if (time) {
        let sendDate = moment(time, 'MM/DD/yy').format('MM/DD/YYYY');
        return `Ship on ${sendDate}`;
      }
      return 'UNSEND';
    },
  },
  props: {
    sendInfo: {
      default: {},
    },
  },
  methods: {
    newWindow(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';

.move-fedex {
  .time {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 90px;
    img {
      width: 79px;
      padding-bottom: 25px;
    }
    .time-info {
      flex: 1;
      height: 100%;
      padding-left: 46px;
      .title {
        .font-light;
        font-size: 18px;
        font-weight: 300;
        line-height: 22px;
        color: @app-black-color;
        .tag {
          color: #fff;
          padding: 0px 12px;
          height: 26px;
          display: inline-block;
          background: @app-tag-color;
          border-radius: 13px;
          font-size: 14px;
          font-weight: 300;
          margin-left: 10px;
          line-height: 26px;
        }
        .text-value {
          .font-regular;
          padding-top: 10px;
          color: @app-black-color;
          font-size: 16px;
          font-weight: 400;
        }
      }
      .note {
        .font-light;
        padding-top: 20px;
        font-size: 16px;
        font-weight: 300;
        color: @app-blue-color;
      }
    }
  }
  .ship-info {
    border-top: 1px solid #eeeff0;
    border-bottom: 1px solid #eeeff0;
    padding-bottom: 35px;
    .row {
      margin-top: 36px;
      display: flex;
      flex-direction: row;
      .shot {
        width: 144px;
        height: 100%;
      }
      .long {
        flex: 1;
        height: 100%;
      }
      .title {
        .font-light;
        color: @app-black-color;
        font-size: 14px;
        font-weight: 300;
      }
      .value {
        .font-regular;
        padding-top: 10px;
        color: @app-black-color;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}
</style>
